import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import DeliveringSubHeader from './DeliveringSubHeader';
import HeaderNotifications from './HeaderNotifications';
import QuestionSubHeader from './QuestionSubHeader';
import ResultSubHeader from './ResultSubHeader';
import TocSubHeader from './TocSubHeader';

import timeReader from '../../store/readHelpers/TimeReader';
import sessionReader from '../../store/readHelpers/SessionReader';

import styles from './header.scss';
import ParentTestSubHeader from './ParentTestSubHeader';
import LivestreamSubheader from './LivestreamSubheader';
import routeTypes from '../../constants/RouteTypes';
import preCheckService from '../../services/PreCheckService';
import SkipLinkContainer from './SkipLink';

export class Header extends React.PureComponent {
    getSubHeader() {
        const {
            currentlyShown,
            isChildTestOverviewPage,
            shouldShowLiveSessionSubheader,
            parentTest,
            isCompactView,
        } = this.props;

        if (isCompactView) {
            return null;
        }

        const isTocPage = currentlyShown.route === '/';
        const isDeliveringPage = currentlyShown.route === '/delivering';
        const isResultPage = currentlyShown.routeType === 'result';

        if (isResultPage) {
            return <ResultSubHeader {...this.props} />;
        } else if (isDeliveringPage) {
            return <DeliveringSubHeader {...this.props} />;
        } else if (isTocPage) {
            return <TocSubHeader {...this.props} />;
        } else if (isChildTestOverviewPage) {
            return <ParentTestSubHeader parentTest={parentTest} />;
        } else if (shouldShowLiveSessionSubheader) {
            return <LivestreamSubheader />;
        }
        return <QuestionSubHeader {...this.props} />;
    }

    render() {
        const {
            apiState,
            currentlyShown,
            hideTimeRemaining,
            showFooter,
            ui,
            isCompactView,
        } = this.props;

        const isResultPage = currentlyShown.routeType === routeTypes.ROUTE_TYPE_RESULT;
        const isPreLoading = apiState.isPreloading ? ' preloading' : '';
        const subHeader = this.getSubHeader();
        const showSkipLink = showFooter && ui.variables.header__showSkipLink;

        const isDeliveringPage = currentlyShown.route === routeTypes.ROUTE_TYPE_DELIVERING;

        const SkipLinkComponent = showSkipLink
            ? <SkipLinkContainer />
            : null;

        let viewStyle = '';
        if (isCompactView) {
            viewStyle = ` ${styles.compact}`;
        } else if (isResultPage) {
            viewStyle = ` ${styles.resultView}`;
        }

        return (
            <React.Fragment>
                {SkipLinkComponent}
                <header
                    className={`${styles.header + isPreLoading + viewStyle} ${isDeliveringPage || isResultPage ? styles.subHeaderWrapper : ''}`}
                    id="header"
                >
                    <HeaderNotifications
                        hideTimeRemaining={hideTimeRemaining}
                    />
                    { subHeader }
                </header>
            </React.Fragment>
        );
    }
}

Header.propTypes = {
    apiState: PropTypes.object.isRequired,
    currentlyShown: PropTypes.object,
    parentTest: PropTypes.object,
    ui: PropTypes.object,
    showFooter: PropTypes.bool,
    isChildTestOverviewPage: PropTypes.bool,
    shouldShowLiveSessionSubheader: PropTypes.bool,
    isStandaloneTestOverviewPage: PropTypes.bool,
    hideTimeRemaining: PropTypes.bool,
    isCompactView: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
    const currentlyShown = state.currentlyShown;
    const isQuestionOrSectionPage = !!currentlyShown.sectionId;
    const isTestOverviewPage = currentlyShown.routeType === routeTypes.ROUTE_TYPE_TEST_OVERVIEW;
    const isChildTestOverviewPage = isTestOverviewPage && sessionReader.isParentTest();
    const isStandaloneTestOverviewPage = isTestOverviewPage && !sessionReader.isParentTest();
    const isSomePreCheckPage = preCheckService.isPreCheckPage(currentlyShown.routeType);
    const isCompactView = isQuestionOrSectionPage || isChildTestOverviewPage
        || isSomePreCheckPage || sessionReader.isRemoteOralExam();
    const hideTimeRemaining = isChildTestOverviewPage || isStandaloneTestOverviewPage || isSomePreCheckPage;

    return {
        apiState: state.api,
        assessment: state.assessment,
        currentlyShown,
        flaggedItems: state.itemFlag.flaggedItems,
        isChildTestOverviewPage,
        isStandaloneTestOverviewPage,
        isCompactView,
        hideTimeRemaining,
        shouldShowLiveSessionSubheader: sessionReader.supportsLivestream() && (isTestOverviewPage || isSomePreCheckPage),
        numberOfQuestions: state.toc.numberOfQuestions,
        parentTest: state.parentTest,
        questionsFilter: state.toc.filter,
        settings: state.settings,
        timeHasExpired: timeReader.timeHasExpired(state),
        ui: state.ui,
    };
}

const HeaderContainer = connect(mapStateToProps)(Header);
export default HeaderContainer;
